import { useState } from "react";
import { FormControl, FormHelperText, TextField } from "@mui/material";

interface TxtDocumentoCPFCNPJProps {
  value: string;
  onChange: (value: string) => void; // envia valor limpo (só números)
  required?: boolean;
  label?: string;
  name?: string;
  disabled?: boolean;
}

export const TxtDocumentoCPFCNPJ = ({
  value,
  onChange,
  required = false,
  label = "Documento CPF ou CNPJ",
  name = "documento",
  disabled = false
}: TxtDocumentoCPFCNPJProps) => {
  const [error, setError] = useState<string>("");

  // Remove tudo que não for número
  const onlyNumbers = (val: string) => val.replace(/\D/g, "");

  // Aplica máscara dinâmica
  const maskDocumento = (val: string) => {
    const v = onlyNumbers(val);
    if (v.length <= 11) {
      // CPF: 000.000.000-00
      return v
        .replace(/^(\d{3})(\d)/, "$1.$2")
        .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
        .replace(/\.(\d{3})(\d)/, ".$1-$2");
    } else {
      // CNPJ: 00.000.000/0000-00
      return v
        .replace(/^(\d{2})(\d)/, "$1.$2")
        .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
        .replace(/\.(\d{3})(\d)/, ".$1/$2")
        .replace(/(\d{4})(\d)/, "$1-$2");
    }
  };

  // Validação simples
  const validateDocumento = (val: string) => {
    const v = onlyNumbers(val);
    if (v.length === 11 || v.length === 14) {
      setError("");
      return true;
    } else {
      setError("Documento inválido (CPF 11 ou CNPJ 14 dígitos)");
      return false;
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = onlyNumbers(e.target.value);
    onChange(rawValue); // envia valor limpo
    validateDocumento(rawValue);
  };

  return (
    <FormControl fullWidth>
      <TextField
        required={required}
        label={label}
        disabled={disabled}
        name={name}
        value={maskDocumento(value)}
        onChange={handleChange}
        size="small"
        inputProps={{ maxLength: 18 }} // CPF 14 + pontuações
        error={!!error}
      />
      <FormHelperText>{error || `${value.length} caracteres`}</FormHelperText>
    </FormControl>
  );
};
